import 'jsplumb/css/jsplumbtoolkit-defaults.css';

import { jsPlumb } from 'jsplumb/dist/js/jsplumb.js';

export default {
  install: Vue => {
    Object.defineProperty(Vue.prototype, '$jsPlumb', {
      value: jsPlumb
    });
  }
};
